import { withBreakpointObserver } from '@studiometa/js-toolkit';
import { Cursor } from '@studiometa/ui';

/**
 * GalleryCursor - Custom cursor for the product gallery
 * Extends the Cursor component from @studiometa/ui
 * Only active on desktop (l breakpoint and above)
 */
export default class GalleryCursor extends withBreakpointObserver(Cursor) {
  static config = {
    ...Cursor.config,
    name: 'GalleryCursor',
    refs: ['icon'],
    options: {
      ...Cursor.config.options,
      targets: {
        type: Array,
        default: () => [],
      },
      activeBreakpoints: {
        type: String,
        default: 'l xl xxl',
      },
    },
  };

  isOver = false;
  isZoomed = false;

  /**
   * @returns {HTMLElement[]}
   */
  get targetElements() {
    if (this.$options.targets.length > 0) {
      return this.$options.targets
        .map((selector) => document.querySelector(selector))
        .filter(Boolean);
    }
    return this.$el.parentElement ? [this.$el.parentElement] : [];
  }

  /**
   * @param {PointerEvent} event
   * @returns {boolean}
   */
  isInsideTarget(event) {
    const target = event.target;

    // Exclure GalleryNav
    if (target instanceof Element && target.closest('[data-component="GalleryNav"]')) {
      return false;
    }

    return this.targetElements.some((el) => el.contains(/** @type {Node} */ (target)));
  }

  /**
   * @param {import('@studiometa/js-toolkit').PointerServiceProps} props
   */
  moved(props) {
    const wasOver = this.isOver;
    this.isOver = this.isInsideTarget(props.event);

    if (this.isOver) {
      if (!wasOver) {
        this.show();
      }
      super.moved(props);
    } else if (wasOver) {
      this.hide();
    }
  }

  /**
   * Show the cursor
   */
  show() {
    this.$refs.icon.classList.remove('scale-0');
  }

  /**
   * Hide the cursor
   */
  hide() {
    this.$refs.icon.classList.add('scale-0');
  }
}
